export const RESET_EVENT_SCHEDULER = 'EventScheduler/RESET_EVENT_SCHEDULER';

export const CREATE_EVENT = 'EventScheduler/CREATE_EVENT';
export const CREATE_EVENT_SET_DATA = 'EventScheduler/CREATE_EVENT_SET_DATA';

export const DELETE_EVENT = 'EventScheduler/DELETE_EVENT';
export const DELETE_EVENT_SET_DATA = 'EventScheduler/DELETE_EVENT_SET_DATA';
